import React from "react";
import Arrow from "../assets/img/arrow-right.png";

export const PreviousArrow = ({ onClick, disabled, hidden }) => {
  return (
    <button
      disabled={disabled}
      className={"btn cat hide-on-mobile"}
      style={{ cursor: "pointer", display: hidden ? "none" : "" }}
      onClick={onClick}>
      <div className="circle">
        <img src={Arrow} alt="" style={{ transform: "rotate(180deg)" }} />
      </div>
      <span style={{ opacity: 0 }}>Ver</span>
    </button>
  );
};

export const NextArrow = ({ onClick, disabled, hidden }) => {
  return (
    <button
      disabled={disabled}
      className={"btn cat hide-on-mobile "}
      style={{ cursor: "pointer", display: hidden ? "none" : "" }}
      onClick={onClick}>
      <div className="circle">
        <img src={Arrow} alt="" style={{ transform: "rotate(0)" }} />
      </div>
      {/* <span>Ver más</span> */}
      <span style={{ opacity: 0 }}>Ver</span>
    </button>
  );
};

export const PreviousArrowMobile = ({ onClick, disabled }) => {
  return (
    <button
      disabled={disabled}
      className="btn cat"
      style={{ display: "flex", cursor: "pointer" }}
      onClick={onClick}>
      <div className="circle" style={{ padding: 0 }}>
        <img
          src={Arrow}
          alt=""
          style={{
            transform: "rotate(180deg)",
            padding: " 2px",
            width: " 40px",
            height: "40px",
          }}
        />
      </div>
      {/* <span>Volver</span> */}
    </button>
  );
};

export const NextArrowMobile = ({ onClick, disabled }) => {
  return (
    <button
      disabled={disabled}
      className="btn cat"
      style={{ display: "flex", cursor: "pointer" }}
      onClick={onClick}>
      <div className="circle" style={{ padding: 0 }}>
        <img
          style={{
            transform: "rotate(0deg)",
            padding: " 2px",
            width: " 40px",
            height: "40px",
          }}
          src={Arrow}
          alt=""
        />
      </div>
      {/* <span>Ver más</span> */}
    </button>
  );
};
